import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureResourceGroupIcon = props => (
  <Icon viewBox="0 0 721 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-302 0)">
      <g>
        <path
          d="M429.711 841.144 429.711 563.995 662.47 697.001 662.47 974.496 429.711 841.144Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="0.701961"
          transform="matrix(1.00263 0 0 1 -20.4427 -322.756)"
        />
        <path
          d="M931.039 563.995 931.039 841.144 698.28 974.496 698.28 697.001 931.039 563.995Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="0.403922"
          transform="matrix(1.00263 0 0 1 -20.4427 -322.756)"
        />
        <path
          d="M680.375 375.997 926.563 519.234 680.375 662.47 434.187 519.234 680.375 375.997ZM375.997 886.278 510.421 964.489 475.591 984.753 473.074 984.753 322.283 897.021 322.283 463.731 473.074 375.998 475.591 375.998 510.421 396.263 375.997 474.474 375.997 886.278ZM984.751 886.278 984.753 474.474 850.327 396.263 885.159 375.997 887.674 375.997 1038.47 463.731 1038.47 897.021 887.674 984.753 885.159 984.753 850.327 964.489 984.751 886.278Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
          transform="matrix(1.00263 0 0 1 -20.4427 -322.756)"
        />
      </g>
    </g>
  </Icon>
);
